// // // import React, { useEffect, useState } from 'react';
// // // import { Link, useLocation, useHistory } from 'react-router-dom';
// // // import { useDispatch, useSelector } from "react-redux";
// // // import { getDoctorProfileById } from '../../actions/doctorActions';
// // // import { logout } from 'src/actions/loginAction';
// // // import { imgUrl } from 'src/actions/types';
// // // import './DoctorSidebar.css';
// // // import { getUserById } from 'src/actions/loginAction';
// // // import { getAccountStatus } from 'src/actions/businessModuleActions';
// // // import { updateUser } from 'src/actions/loginAction';
// // // import { getBusinessAddons } from 'src/actions/businessAddonActions';

// // // const DoctorSidebar = ({ onClose, isMobile }) => {
// // //   const location = useLocation();
// // //   const history = useHistory();
// // //   const dispatch = useDispatch();
// // //   const currentPath = location.pathname;

// // //   const hospitalID = parseInt(localStorage.getItem('hospitalCode'), 10);
// // //   const { profileData: doctorProfile } = useSelector((state) => state.doctorProfile);
// // //   const userRole = localStorage.getItem('StaffRole');
// // //     const { businessAddons } = useSelector((state) => state.businessAddons);
// // //   const [subscriptionStatus, setSubscriptionStatus] = useState(null);
// // //   const [loading, setLoading] = useState(true);
// // //   const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
// // //   const [restrictedFeature, setRestrictedFeature] = useState('');
// // //  const hasBlogAddon = businessAddons?.some(
// // //     (addon) => addon.addon_name === "Blog Management" && addon.status?.toLowerCase() === "active"
// // //   );
// // //   useEffect(() => {
// // //   if (hospitalID) {
// // //     dispatch(getBusinessAddons(hospitalID)); 
// // //   }
// // // }, [dispatch, hospitalID]);
// // //   // useEffect(() => {
// // //   //   const hospitalID = localStorage.getItem('hospitalCode');
// // //   //   async function checkAndUpdateSubscription() {
// // //   //     if (!hospitalID) return;
// // //   //     try {
// // //   //       const accountStatus = await getAccountStatus(hospitalID);
// // //   //       const hasActiveSubscription = !!accountStatus?.subscription_status;

// // //   //       if (!hasActiveSubscription) {
// // //   //         const userUpdateData = {
// // //   //           hospitalID: hospitalID,
// // //   //           subscription_status: null,
// // //   //           Subscription_type: null
// // //   //         };
// // //   //         await updateUser(userUpdateData);
// // //   //       }
// // //   //     } catch (error) {
// // //   //       console.error('[Subscription Check] Error:', error);
// // //   //     }
// // //   //   }

// // //   //   checkAndUpdateSubscription();
// // //   // }, [updateUser, getAccountStatus]);

// // //   // useEffect(() => {
// // //   //   const checkUserSubscription = async () => {
// // //   //     try {
// // //   //       if (hospitalID) {
// // //   //         const subscriptionData = await getUserById(hospitalID);
// // //   //         setSubscriptionStatus(subscriptionData || 'inactive');
// // //   //         dispatch(getDoctorProfileById(hospitalID));
// // //   //       }
// // //   //     } catch (error) {
// // //   //       console.error("Error checking subscription:", error);
// // //   //       setSubscriptionStatus('inactive');
// // //   //     } finally {
// // //   //       setLoading(false);
// // //   //     }
// // //   //   };

// // //   //   checkUserSubscription();
// // //   // }, [dispatch, hospitalID]);
// // // // DoctorSidebar.js mein ye hissa badlein

// // // // useEffect(() => {
// // // //   const checkUserSubscription = async () => {
// // // //     try {
// // // //       if (hospitalID) {
// // // //         // 1. Pehle LocalStorage se check karein (Instant update ke liye)
// // // //         const localData = JSON.parse(localStorage.getItem('loginData') || '{}');
// // // //         if (localData.subscription_status) {
// // // //           setSubscriptionStatus(localData.subscription_status);
// // // //         }

// // // //         // 2. Fir Server se verify karein
// // // //         const subscriptionData = await getUserById(hospitalID);
        
// // // //         // DHAYN DEIN: subscriptionData.subscription_status nikalna hai
// // // //         const status = subscriptionData?.subscription_status || 'inactive';
// // // //         setSubscriptionStatus(status);
        
// // // //         dispatch(getDoctorProfileById(hospitalID));
// // // //       }
// // // //     } catch (error) {
// // // //       console.error("Error checking subscription:", error);
// // // //       setSubscriptionStatus('inactive');
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   };

// // // //   checkUserSubscription();
// // // // }, [dispatch, hospitalID]);

// // // // Check karne ka tarika wahi rahega
// // // useEffect(() => {
// // //   const verifyBasePlanStatus = async () => {
// // //     try {
// // //       if (hospitalID) {
// // //         // 1. Server se Business Module ka status check karein
// // //         // Hum check kar rahe hain ki kya koi 'Paid' plan active hai?
// // //         const response = await dispatch(getAccountStatus(hospitalID));
        
// // //         // Maa lijiye API return karta hai { subscription_status: 'active', Subscription_type: 'subscription' }
// // //         const currentStatus = response?.subscription_status || 'inactive';
// // //         const currentType = response?.Subscription_type || null;

// // //         // 2. LocalStorage ko sync karein (Taki refresh par status yaad rahe)
// // //         const localDataString = localStorage.getItem('loginData');
// // //         if (localDataString) {
// // //           let loginData = JSON.parse(localDataString);
          
// // //           // Agar database aur local storage ka status alag hai, toh local ko update karein
// // //           if (loginData.subscription_status !== currentStatus) {
// // //             loginData.subscription_status = currentStatus;
// // //             loginData.Subscription_type = currentType;
// // //             localStorage.setItem('loginData', JSON.stringify(loginData));
            
// // //             // Backend User table ko bhi sync mein rakhein (Action Call)
// // //             const userUpdatePayload = {
// // //                ...loginData,
// // //                subscription_status: currentStatus,
// // //                Subscription_type: currentType
// // //             };
// // //             dispatch(updateUser(userUpdatePayload));
// // //           }
// // //         }

// // //         // 3. Component state update karein taki UI lock/unlock ho jaye
// // //         setSubscriptionStatus(currentStatus);
// // //         dispatch(getDoctorProfileById(hospitalID));
// // //       }
// // //     } catch (error) {
// // //       console.error("Subscription Verification Failed:", error);
// // //       // Error hone par purana local status hi dikhayein safety ke liye
// // //       const localData = JSON.parse(localStorage.getItem('loginData') || '{}');
// // //       setSubscriptionStatus(localData.subscription_status || 'inactive');
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   verifyBasePlanStatus();
// // // }, [dispatch, hospitalID]);

// // // // Check karne ka tarika (Case-insensitive banayein taaki 'Active' ya 'active' dono chalein)
// // // const isSubscriptionActive = String(subscriptionStatus).toLowerCase() === 'active';

// // // // const isSubscriptionActive = subscriptionStatus === 'active';
// // //   const handleLogout = (e) => {
// // //     e.preventDefault();
// // //     dispatch(logout());
// // //   };

// // //   const handleRestrictedClick = (e, featureName) => {
// // //     e.preventDefault();
// // //     setRestrictedFeature(featureName);
// // //     setShowSubscriptionModal(true);
// // //   };

// // //   const handleUpgradeNow = () => {
// // //     setShowSubscriptionModal(false);
// // //     history.push('/doctor/plan-selection');
// // //     if (onClose) onClose();
// // //   };

// // //   const handleCancel = () => {
// // //     setShowSubscriptionModal(false);
// // //   };

// // //   // Handle menu item click for mobile
// // //   const handleMenuItemClick = () => {
// // //     if (isMobile && onClose) {
// // //       onClose();
// // //     }
// // //   };

// // //   const isActive = (path) => currentPath === path;
// // //   // const isSubscriptionActive = subscriptionStatus === 'active';

// // //   // Menu configuration
// // //   const menuItems = [
    
// // //     { path: '/doctor/dashboard', icon: 'fas fa-columns', label: 'Dashboard', requiresSubscription: true },
// // //     { path: '/doctor/appointments', icon: 'fas fa-calendar-check', label: 'Appointments', requiresSubscription: true },
// // //     { path: '/doctor/my-patients', icon: 'fas fa-user-injured', label: 'Patients', requiresSubscription: true },
// // //     { path: '/doctor/schedule-timings', icon: 'fas fa-hourglass-start', label: 'Schedule Timings', requiresSubscription: true },
// // //     { path: '/doctor/reminder-tab', icon: 'fa-solid fa-calendar-check', label: 'Reminder', requiresSubscription: true },
// // //     { path: '/doctor/Exercise-chart', icon: 'fa-solid fa-person-running', label: 'Exercise-chart', requiresSubscription: true },
// // //     { path: '/doctor/diet-chart', icon: 'fas fa-bowl-rice', label: 'diet-chart', requiresSubscription: true },
// // //     { path: '/doctor/reviews', icon: 'fas fa-star', label: 'Reviews', requiresSubscription: true },
// // //     { path: '/doctor/chat', icon: 'fas fa-comments', label: 'Messages', requiresSubscription: true, badge: 23 },
// // //     { path: '/doctor/profile-settings', icon: 'fas fa-user-cog', label: 'Profile Settings', requiresSubscription: true },
// // //     { path: '/doctor/my-blogs', icon: 'fas fa-blog', label: 'Blogs', requiresSubscription: true },
// // //     { path: '/doctor/social-media', icon: 'fas fa-share-alt', label: 'Social Media', requiresSubscription: true },
// // //     { path: '/doctor/change-password', icon: 'fas fa-lock', label: 'Change Password', requiresSubscription: true },
// // //     { path: '/doctor/ReportSettingsEditor', icon: 'fas fa-file-alt', label: 'Report Settings', requiresSubscription: true },
// // //     { path: '/doctor/transaction-list', icon: 'fas fa-exchange-alt', label: 'Transactions', requiresSubscription: true },
// // //     { path: '/doctor/plan-selection', icon: 'fas fa-cog', label: 'System Setting', requiresSubscription: false },
// // //     { path: '/doctor/payout-history', icon: 'fas fa-history', label: 'Payout History', requiresSubscription: true },

    
    
// // //   ];

// // //   // const renderMenuItem = (item) => {
// // //   //   const isItemActive = isActive(item.path);
// // //   //   // const canAccess = isSubscriptionActive || !item.requiresSubscription;
// // //   //    const isBlogItem = item.label === 'Blogs';
// // //   // const addonMissing = isBlogItem && !hasBlogAddon; 
// // //   // const canAccess = (isSubscriptionActive || !item.requiresSubscription) && !addonMissing;
// // //   //   if (!canAccess) {
// // //   //     return (
// // //   //       <li key={item.path} className="locked-item">
// // //   //         <a
// // //   //           href="#restricted"
// // //   //           className="restricted-link"
// // //   //           onClick={(e) => handleRestrictedClick(e, item.label)}
// // //   //         >
// // //   //           <i className={item.icon} />
// // //   //           <span>{item.label}</span>
// // //   //           <i className="fas fa-lock lock-icon" />
// // //   //         </a>
// // //   //       </li>
// // //   //     );
// // //   //   }
     

// // //   //    if (!canAccess) {
// // //   //   return (
// // //   //     <li key={item.path} className="locked-item">
// // //   //       <a
// // //   //         href="#restricted"
// // //   //         className="restricted-link"
// // //   //         onClick={(e) => {
// // //   //           e.preventDefault();
           
// // //   //           setRestrictedFeature(isBlogItem && !hasBlogAddon ? "Blog Management Addon" : item.label);
// // //   //           setShowSubscriptionModal(true);
// // //   //         }}
// // //   //       >
// // //   //         <i className={item.icon} />
// // //   //         <span>{item.label}</span>
// // //   //         <i className="fas fa-lock lock-icon" /> 
// // //   //       </a>
// // //   //     </li>
// // //   //   );
// // //   // }
// // //   //   return (
// // //   //     <li key={item.path} className={isItemActive ? 'active' : ''}>
// // //   //       <Link to={item.path} onClick={handleMenuItemClick}>
// // //   //         <i className={item.icon} />
// // //   //         <span>{item.label}</span>
// // //   //         {item.badge && <small className="unread-msg">{item.badge}</small>}
// // //   //       </Link>
// // //   //     </li>
// // //   //   );
// // //   // };
// // // const renderMenuItem = (item) => {
// // //     const isItemActive = isActive(item.path);
// // //     const isBlogItem = item.label === 'Blogs';
    
// // //     // Base Plan Check: Agar status 'active' nahi hai toh menu lock rahega
// // //     // Exception: requiresSubscription: false (System Setting) hamesha khula rahega
// // //     const isSubActive = String(subscriptionStatus).toLowerCase() === 'active';
    
// // //     // Blog ke liye alag se addon check (jo aapne pehle lagaya tha)
// // //     const addonMissing = isBlogItem && !hasBlogAddon; 
    
// // //     const canAccess = (isSubActive || !item.requiresSubscription) && !addonMissing;

// // //     if (!canAccess) {
// // //       return (
// // //         <li key={item.path} className="locked-item">
// // //           <a
// // //             href="#restricted"
// // //             className="restricted-link"
// // //             onClick={(e) => handleRestrictedClick(e, isBlogItem && !hasBlogAddon ? "Blog Management Addon" : item.label)}
// // //           >
// // //             <i className={item.icon} />
// // //             <span>{item.label}</span>
// // //             <i className="fas fa-lock lock-icon" />
// // //           </a>
// // //         </li>
// // //       );
// // //     }

// // //     return (
// // //       <li key={item.path} className={isItemActive ? 'active' : ''}>
// // //         <Link to={item.path} onClick={handleMenuItemClick}>
// // //           <i className={item.icon} />
// // //           <span>{item.label}</span>
// // //           {item.badge && <small className="unread-msg">{item.badge}</small>}
// // //         </Link>
// // //       </li>
// // //     );
// // // };
// // //   if (loading) {
// // //     return (
// // //       <div className="profile-sidebar" style={isMobile ? { height: '100vh', overflowY: 'auto' } : {}}>
// // //         <div className="loading-section">
// // //           <div className="spinner-border text-primary" role="status">
// // //             <span className="sr-only">Loading...</span>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     );
// // //   }

// // //   return (
// // //     <>
// // //     <style>
// // //         {`
// // //           .profile-sidebar::-webkit-scrollbar { display: none; }
// // //           .profile-sidebar { -ms-overflow-style: none; scrollbar-width: none; }
// // //         `}
// // //       </style>
      
// // //       <div className="profile-sidebar" style={isMobile ? { height: '100vh', overflowY: 'auto' } : {}}>
// // //         {/* Mobile Close Button - Only show on mobile */}
// // //         {isMobile && (
// // //           <div className="mobile-sidebar-header">
// // //             <button
// // //               className="btn-danger"
// // //               onClick={onClose}
// // //               aria-label="Close sidebar"
// // //             >×

// // //             </button>
// // //           </div>
// // //         )}

// // //         {/* Profile Widget */}
// // //         <div className="widget-profile pro-widget-content">
// // //           <div className="profile-info-widget">
// // //            <div className="booking-doc-img">
// // //             <img
// // //               src={
// // //                 doctorProfile?.uploadPhoto
// // //                   ? `${imgUrl}${doctorProfile.uploadPhoto}`
// // //                   : "/assets/img/defaultDoctorProfile.jpg" // Updated path
// // //               }
// // //               alt="User"
// // //               onError={(e) => {
// // //                 e.target.src = "/assets/img/defaultDoctorProfile.jpg"; // Updated fallback
// // //               }}
// // //             />
// // //           </div>
            
// // //             <div className="profile-det-info">
// // //               <h3>
// // //                 Dr. {doctorProfile?.firstName || 'Loading...'} {doctorProfile?.lastName || ''}
// // //               </h3>
// // //               <div className="patient-details">
// // //                 {doctorProfile?.Educations?.length > 0 ? (
// // //                   doctorProfile.Educations.map((edu, i) => (
// // //                     <h5 className="mb-0" key={edu.id || i}>
// // //                       {edu.Degree}
// // //                       {i < doctorProfile.Educations.length - 1 ? ', ' : ''}
// // //                     </h5>
// // //                   ))
// // //                 ) : (
// // //                   <h5>No Education Info</h5>
// // //                 )}

// // //                 <div className="mt-2">
// // //                   {doctorProfile?.Specializations?.length > 0 ? (
// // //                     doctorProfile.Specializations.map((spec, i) => (
// // //                       <span
// // //                         key={spec.id || i}
// // //                         className="badge badge-info mr-1 mb-1"
// // //                       >
// // //                         {spec.Specialization}
// // //                       </span>
// // //                     ))
// // //                   ) : (
// // //                     <span className="badge badge-secondary">No Specializations</span>
// // //                   )}
// // //                 </div>

// // //                 {/* Subscription Status Badge */}
// // //                 <div className="mt-2">
// // //                   <span className={`badge ${isSubscriptionActive ? 'badge-success' : 'badge-warning'
// // //                     }`}>
// // //                     {isSubscriptionActive ? 'Active Subscription' : 'Subscription Required'}
// // //                   </span>
// // //                 </div>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         {/* Navigation Menu */}
// // //         <div className="dashboard-widget">
// // //           <nav className="dashboard-menu">
// // //             <ul>
// // //               {menuItems.map(renderMenuItem)}

// // //               {/* Logout Button */}
// // //               <li>
// // //                 <a href="#logout" onClick={handleLogout}>
// // //                   <i className="fas fa-sign-out-alt" />
// // //                   <span>Logout</span>
// // //                 </a>
// // //               </li>
// // //             </ul>
// // //           </nav>
// // //         </div>
// // //       </div>

      
// // //     </>
// // //   );
// // // };

// // // export default DoctorSidebar;

































// // import React, { useEffect, useState } from 'react';
// // import { Link, useLocation, useHistory } from 'react-router-dom';
// // import { useDispatch, useSelector } from "react-redux";
// // import { getDoctorProfileById } from '../../actions/doctorActions';
// // import { logout } from 'src/actions/loginAction';
// // import { imgUrl } from 'src/actions/types';
// // import './DoctorSidebar.css';
// // import { getUserById } from 'src/actions/loginAction';
// // import { getAccountStatus } from 'src/actions/businessModuleActions';
// // import { updateUser } from 'src/actions/loginAction';

// // const DoctorSidebar = ({ onClose, isMobile }) => {
// //   const location = useLocation();
// //   const history = useHistory();
// //   const dispatch = useDispatch();
// //   const currentPath = location.pathname;

// //   const hospitalID = parseInt(localStorage.getItem('hospitalCode'), 10);
// //   const { profileData: doctorProfile } = useSelector((state) => state.doctorProfile);
// //   const userRole = localStorage.getItem('StaffRole');

// //   const [subscriptionStatus, setSubscriptionStatus] = useState(null);
// //   const [loading, setLoading] = useState(true);
// //   const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
// //   const [restrictedFeature, setRestrictedFeature] = useState('');

// //   useEffect(() => {
// //     const hospitalID = localStorage.getItem('hospitalCode');
// //     async function checkAndUpdateSubscription() {
// //       if (!hospitalID) return;
// //       try {
// //         const accountStatus = await getAccountStatus(hospitalID);
// //         const hasActiveSubscription = !!accountStatus?.subscription_status;

// //         if (!hasActiveSubscription) {
// //           const userUpdateData = {
// //             hospitalID: hospitalID,
// //             subscription_status: null,
// //             Subscription_type: null
// //           };
// //           await updateUser(userUpdateData);
// //         }
// //       } catch (error) {
// //         console.error('[Subscription Check] Error:', error);
// //       }
// //     }

// //     checkAndUpdateSubscription();
// //   }, [updateUser, getAccountStatus]);

// //   // useEffect(() => {
// //   //   const checkUserSubscription = async () => {
// //   //     try {
// //   //       if (hospitalID) {
// //   //         const subscriptionData = await getUserById(hospitalID);
// //   //         setSubscriptionStatus(subscriptionData || 'inactive');
// //   //         dispatch(getDoctorProfileById(hospitalID));
// //   //       }
// //   //     } catch (error) {
// //   //       console.error("Error checking subscription:", error);
// //   //       setSubscriptionStatus('inactive');
// //   //     } finally {
// //   //       setLoading(false);
// //   //     }
// //   //   };

// //   //   checkUserSubscription();
// //   // }, [dispatch, hospitalID]);
// // useEffect(() => {
// //   const verifyBasePlanStatus = async () => {
// //     try {
// //       if (hospitalID) {
// //         // 1. Instant UI Update: Pehle LocalStorage se data uthao taaki UI turant khul jaye
// //         const localDataString = localStorage.getItem('loginData');
// //         let localData = localDataString ? JSON.parse(localDataString) : {};
        
// //         if (localData.subscription_status) {
// //           setSubscriptionStatus(localData.subscription_status);
// //         }

// //         // 2. Background Verification: Server se Business Module ka status check karein
// //         // Hum check kar rahe hain ki primary source (DB) mein kya status hai
// //         const response = await dispatch(getAccountStatus(hospitalID));
        
// //         const currentStatus = response?.subscription_status || 'inactive';
// //         const currentType = response?.Subscription_type || null;

// //         // 3. Sync Check: Agar DB aur LocalStorage ka status alag hai, toh sync karein
// //         if (localData.subscription_status !== currentStatus) {
          
// //           // Local Storage update karein
// //           localData.subscription_status = currentStatus;
// //           localData.Subscription_type = currentType;
// //           localStorage.setItem('loginData', JSON.stringify(localData));
          
// //           // Component State update karein (UI refresh ke liye)
// //           setSubscriptionStatus(currentStatus);

// //           // Backend User Table sync karein (Taki refresh par issue na aaye)
// //           const userUpdatePayload = {
// //              ...localData,
// //              subscription_status: currentStatus,
// //              Subscription_type: currentType
// //           };
// //           // Pura object bhej rahe hain taaki API 500 error na de
// //           dispatch(updateUser(userUpdatePayload));
// //         }

// //         // Profile data load karein
// //         dispatch(getDoctorProfileById(hospitalID));
// //       }
// //     } catch (error) {
// //       console.error("Subscription Sync Failed:", error);
// //       // Error hone par purana local status hi rehne dein safety ke liye
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   verifyBasePlanStatus();
// // }, [dispatch, hospitalID]);
// //   const handleLogout = (e) => {
// //     e.preventDefault();
// //     dispatch(logout());
// //   };

// //   const handleRestrictedClick = (e, featureName) => {
// //     e.preventDefault();
// //     setRestrictedFeature(featureName);
// //     setShowSubscriptionModal(true);
// //   };

// //   const handleUpgradeNow = () => {
// //     setShowSubscriptionModal(false);
// //     history.push('/doctor/plan-selection');
// //     if (onClose) onClose();
// //   };

// //   const handleCancel = () => {
// //     setShowSubscriptionModal(false);
// //   };

// //   // Handle menu item click for mobile
// //   const handleMenuItemClick = () => {
// //     if (isMobile && onClose) {
// //       onClose();
// //     }
// //   };
// // useEffect(() => {
// //   if (hospitalID) {
// //     // Ye API bina ruke turant Doctor ka data mangwayegi
// //     dispatch(getDoctorProfileById(hospitalID));
// //   }
// // }, [dispatch, hospitalID]);
// //   const isActive = (path) => currentPath === path;
// //   // const isSubscriptionActive = subscriptionStatus === 'active';
// // const isSubscriptionActive = String(subscriptionStatus).toLowerCase() === 'active';
// //   // Menu configuration
// //   const menuItems = [
    
// //     { path: '/doctor/dashboard', icon: 'fas fa-columns', label: 'Dashboard', requiresSubscription: true },
// //     { path: '/doctor/appointments', icon: 'fas fa-calendar-check', label: 'Appointments', requiresSubscription: true },
// //     { path: '/doctor/my-patients', icon: 'fas fa-user-injured', label: 'Patients', requiresSubscription: true },
// //     { path: '/doctor/schedule-timings', icon: 'fas fa-hourglass-start', label: 'Schedule Timings', requiresSubscription: true },
// //     { path: '/doctor/reminder-tab', icon: 'fa-solid fa-calendar-check', label: 'Reminder', requiresSubscription: true },
// //     { path: '/doctor/Exercise-chart', icon: 'fa-solid fa-person-running', label: 'Exercise-chart', requiresSubscription: true },
// //     { path: '/doctor/reviews', icon: 'fas fa-star', label: 'Reviews', requiresSubscription: true },
// //     { path: '/doctor/chat', icon: 'fas fa-comments', label: 'Messages', requiresSubscription: true, badge: 23 },
// //     { path: '/doctor/profile-settings', icon: 'fas fa-user-cog', label: 'Profile Settings', requiresSubscription: true },
// //     { path: '/doctor/my-blogs', icon: 'fas fa-blog', label: 'Blogs', requiresSubscription: true },
// //     { path: '/doctor/social-media', icon: 'fas fa-share-alt', label: 'Social Media', requiresSubscription: true },
// //     { path: '/doctor/change-password', icon: 'fas fa-lock', label: 'Change Password', requiresSubscription: true },
// //     { path: '/doctor/ReportSettingsEditor', icon: 'fas fa-file-alt', label: 'Report Settings', requiresSubscription: true },
// //     { path: '/doctor/transaction-list', icon: 'fas fa-exchange-alt', label: 'Transactions', requiresSubscription: true },
// //     { path: '/doctor/plan-selection', icon: 'fas fa-cog', label: 'System Setting', requiresSubscription: false },
// //     { path: '/doctor/payout-history', icon: 'fas fa-history', label: 'Payout History', requiresSubscription: true },

    
    
// //   ];

// //   // const renderMenuItem = (item) => {
// //   //   const isItemActive = isActive(item.path);
// //   //   const canAccess = isSubscriptionActive || !item.requiresSubscription;

// //   //   if (!canAccess) {
// //   //     return (
// //   //       <li key={item.path} className="locked-item">
// //   //         <a
// //   //           href="#restricted"
// //   //           className="restricted-link"
// //   //           onClick={(e) => handleRestrictedClick(e, item.label)}
// //   //         >
// //   //           <i className={item.icon} />
// //   //           <span>{item.label}</span>
// //   //           <i className="fas fa-lock lock-icon" />
// //   //         </a>
// //   //       </li>
// //   //     );
// //   //   }

// //   //   return (
// //   //     <li key={item.path} className={isItemActive ? 'active' : ''}>
// //   //       <Link to={item.path} onClick={handleMenuItemClick}>
// //   //         <i className={item.icon} />
// //   //         <span>{item.label}</span>
// //   //         {item.badge && <small className="unread-msg">{item.badge}</small>}
// //   //       </Link>
// //   //     </li>
// //   //   );
// //   // };
// // const renderMenuItem = (item) => {
// //     const isItemActive = isActive(item.path);
    
// //     // Check karein ki kya user ke paas access hai?
// //     // Case 1: Plan active hai.
// //     // Case 2: Item ko subscription ki zaroorat hi nahi hai (e.g., System Setting).
// //     const canAccess = isSubscriptionActive || !item.requiresSubscription;

// //     if (!canAccess) {
// //       return (
// //         <li key={item.path} className="locked-item">
// //           <a
// //             href="#restricted"
// //             className="restricted-link"
// //             onClick={(e) => handleRestrictedClick(e, item.label)}
// //           >
// //             <i className={item.icon} />
// //             <span>{item.label}</span>
// //             <i className="fas fa-lock lock-icon" /> {/* Lock icon dikhayenge */}
// //           </a>
// //         </li>
// //       );
// //     }

// //     // Agar access hai toh normal Link dikhayein
// //     return (
// //       <li key={item.path} className={isItemActive ? 'active' : ''}>
// //         <Link to={item.path} onClick={handleMenuItemClick}>
// //           <i className={item.icon} />
// //           <span>{item.label}</span>
// //           {item.badge && <small className="unread-msg">{item.badge}</small>}
// //         </Link>
// //       </li>
// //     );
// // };
// //   if (loading) {
// //     return (
// //       <div className="profile-sidebar" style={isMobile ? { height: '100vh', overflowY: 'auto' } : {}}>
// //         <div className="loading-section">
// //           <div className="spinner-border text-primary" role="status">
// //             <span className="sr-only">Loading...</span>
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   }

// //   return (
// //     <>
// //     <style>
// //         {`
// //           .profile-sidebar::-webkit-scrollbar { display: none; }
// //           .profile-sidebar { -ms-overflow-style: none; scrollbar-width: none; }
// //         `}
// //       </style>
      
// //       <div className="profile-sidebar" style={isMobile ? { height: '100vh', overflowY: 'auto' } : {}}>
// //         {/* Mobile Close Button - Only show on mobile */}
// //         {isMobile && (
// //           <div className="mobile-sidebar-header">
// //             <button
// //               className="btn-danger"
// //               onClick={onClose}
// //               aria-label="Close sidebar"
// //             >×

// //             </button>
// //           </div>
// //         )}

// //         {/* Profile Widget */}
// //         <div className="widget-profile pro-widget-content">
// //           <div className="profile-info-widget">
// //            <div className="booking-doc-img">
// //             <img
// //               src={
// //                 doctorProfile?.uploadPhoto
// //                   ? `${imgUrl}${doctorProfile.uploadPhoto}`
// //                   : "/assets/img/defaultDoctorProfile.jpg" // Updated path
// //               }
// //               alt="User"
// //               onError={(e) => {
// //                 e.target.src = "/assets/img/defaultDoctorProfile.jpg"; // Updated fallback
// //               }}
// //             />
// //           </div>
            
// //             <div className="profile-det-info">
// //               <h3>
// //                 Dr. {doctorProfile?.firstName || 'Loading...'} {doctorProfile?.lastName || ''}
// //               </h3>
// //               <div className="patient-details">
// //                 {doctorProfile?.Educations?.length > 0 ? (
// //                   doctorProfile.Educations.map((edu, i) => (
// //                     <h5 className="mb-0" key={edu.id || i}>
// //                       {edu.Degree}
// //                       {i < doctorProfile.Educations.length - 1 ? ', ' : ''}
// //                     </h5>
// //                   ))
// //                 ) : (
// //                   <h5>No Education Info</h5>
// //                 )}

// //                 <div className="mt-2">
// //                   {doctorProfile?.Specializations?.length > 0 ? (
// //                     doctorProfile.Specializations.map((spec, i) => (
// //                       <span
// //                         key={spec.id || i}
// //                         className="badge badge-info mr-1 mb-1"
// //                       >
// //                         {spec.Specialization}
// //                       </span>
// //                     ))
// //                   ) : (
// //                     <span className="badge badge-secondary">No Specializations</span>
// //                   )}
// //                 </div>

// //                 {/* Subscription Status Badge */}
// //                 <div className="mt-2">
// //                   <span className={`badge ${isSubscriptionActive ? 'badge-success' : 'badge-warning'
// //                     }`}>
// //                     {isSubscriptionActive ? 'Active Subscription' : 'Subscription Required'}
// //                   </span>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Navigation Menu */}
// //         <div className="dashboard-widget">
// //           <nav className="dashboard-menu">
// //             <ul>
// //               {menuItems.map(renderMenuItem)}

// //               {/* Logout Button */}
// //               <li>
// //                 <a href="#logout" onClick={handleLogout}>
// //                   <i className="fas fa-sign-out-alt" />
// //                   <span>Logout</span>
// //                 </a>
// //               </li>
// //             </ul>
// //           </nav>
// //         </div>
// //       </div>

      
// //     </>
// //   );
// // };

// // export default DoctorSidebar;















// import React, { useEffect, useState } from 'react';
// import { Link, useLocation, useHistory } from 'react-router-dom';
// import { useDispatch, useSelector } from "react-redux";
// import { getDoctorProfileById } from '../../actions/doctorActions';
// import { logout } from 'src/actions/loginAction';
// import { imgUrl } from 'src/actions/types';
// import './DoctorSidebar.css';
// import { getUserById } from 'src/actions/loginAction';
// import { getAccountStatus } from 'src/actions/businessModuleActions';
// import { updateUser } from 'src/actions/loginAction';
// import { getBusinessAddons } from 'src/actions/businessAddonActions';
// const DoctorSidebar = ({ onClose, isMobile }) => {
//   const location = useLocation();
//   const history = useHistory();
//   const dispatch = useDispatch();
//   const currentPath = location.pathname;

//   const hospitalID = parseInt(localStorage.getItem('hospitalCode'), 10);
//   const { profileData: doctorProfile } = useSelector((state) => state.doctorProfile);
//   const userRole = localStorage.getItem('StaffRole');
// const { businessAddons } = useSelector((state) => state.businessAddons || { businessAddons: [] });
//   const [subscriptionStatus, setSubscriptionStatus] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
//   const [restrictedFeature, setRestrictedFeature] = useState('');
// useEffect(() => {
//   if (hospitalID) {
//     dispatch(getBusinessAddons({ hospitalID: hospitalID }));
//   }
// }, [dispatch, hospitalID]);
//   useEffect(() => {
//     const hospitalID = localStorage.getItem('hospitalCode');
//     async function checkAndUpdateSubscription() {
//       if (!hospitalID) return;
//       try {
//         const accountStatus = await getAccountStatus(hospitalID);
//         const hasActiveSubscription = !!accountStatus?.subscription_status;

//         if (!hasActiveSubscription) {
//           const userUpdateData = {
//             hospitalID: hospitalID,
//             subscription_status: null,
//             Subscription_type: null
//           };
//           await updateUser(userUpdateData);
//         }
//       } catch (error) {
//         console.error('[Subscription Check] Error:', error);
//       }
//     }

//     checkAndUpdateSubscription();
//   }, [updateUser, getAccountStatus]);

//   // useEffect(() => {
//   //   const verifyBasePlanStatus = async () => {
//   //     console.log('[Subscription Debug] Starting verification...');
//   //     console.log('[Subscription Debug] HospitalID:', hospitalID);
      
//   //     // Log current localStorage data
//   //     const localDataString = localStorage.getItem('loginData');
//   //     console.log('[Subscription Debug] Raw loginData from localStorage:', localDataString);
      
//   //     let localData = localDataString ? JSON.parse(localDataString) : {};
//   //     console.log('[Subscription Debug] Parsed loginData:', localData);
//   //     console.log('[Subscription Debug] subscriptionStatus from localStorage:', localStorage.getItem('subscriptionStatus'));
      
//   //     try {
//   //       if (hospitalID) {
//   //         // First, set from localStorage for immediate UI update
//   //         if (localData.subscription_status) {
//   //           console.log('[Subscription Debug] Setting initial status from localStorage:', localData.subscription_status);
//   //           setSubscriptionStatus(localData.subscription_status);
//   //         } else {
//   //           console.log('[Subscription Debug] No subscription_status in loginData');
//   //         }

//   //         // Then verify with server
//   //         console.log('[Subscription Debug] Calling getAccountStatus for hospitalID:', hospitalID);
//   //         const response = await dispatch(getAccountStatus(hospitalID));
//   //         console.log('[Subscription Debug] getAccountStatus response:', response);
          
//   //         const currentStatus = response?.overallStatus || 'inactive';
//   //         const currentType = response?.currentPlan?.businessType || null;
          
//   //         console.log('[Subscription Debug] Server returned status:', currentStatus);
//   //         console.log('[Subscription Debug] Server returned type:', currentType);
//   //         console.log('[Subscription Debug] Active modules from server:', response?.activeModules);
//   //         console.log('[Subscription Debug] Module access from server:', response?.moduleAccess);

//   //         // Check if there are any active plans
//   //         const hasActivePlan = response?.allPlans?.active && 
//   //           (response.allPlans.active.subscription?.length > 0 || response.allPlans.active.commission?.length > 0);
          
//   //         console.log('[Subscription Debug] Has active plan:', hasActivePlan);
//   //         console.log('[Subscription Debug] Active subscription plans:', response?.allPlans?.active?.subscription);
//   //         console.log('[Subscription Debug] Active commission plans:', response?.allPlans?.active?.commission);

//   //         // Sync if different
//   //         if (localData.subscription_status !== currentStatus) {
//   //           console.log('[Subscription Debug] Status mismatch detected!');
//   //           console.log('[Subscription Debug] Local:', localData.subscription_status, 'Server:', currentStatus);
            
//   //           // Update local storage
//   //           localData.subscription_status = currentStatus;
//   //           localData.Subscription_type = currentType;
//   //           localStorage.setItem('loginData', JSON.stringify(localData));
//   //           console.log('[Subscription Debug] Updated loginData in localStorage:', localData);
            
//   //           // Also update the separate subscriptionStatus key
//   //           localStorage.setItem('subscriptionStatus', currentStatus);
//   //           console.log('[Subscription Debug] Updated subscriptionStatus in localStorage:', currentStatus);
            
//   //           // Update component state
//   //           console.log('[Subscription Debug] Setting subscriptionStatus to:', currentStatus);
//   //           setSubscriptionStatus(currentStatus);
            
//   //           // Update user in backend
//   //           console.log('[Subscription Debug] Dispatching updateUser with payload:', {
//   //             ...localData,
//   //             subscription_status: currentStatus,
//   //             Subscription_type: currentType
//   //           });
//   //           dispatch(updateUser({
//   //             ...localData,
//   //             subscription_status: currentStatus,
//   //             Subscription_type: currentType
//   //           }));
//   //         } else {
//   //           console.log('[Subscription Debug] Status matches, no update needed');
//   //         }

//   //         // Load profile data
//   //         console.log('[Subscription Debug] Dispatching getDoctorProfileById');
//   //         dispatch(getDoctorProfileById(hospitalID));
//   //       }
//   //     } catch (error) {
//   //       console.error("[Subscription Debug] Error in verification:", error);
//   //       console.error("[Subscription Debug] Error details:", {
//   //         message: error.message,
//   //         response: error.response?.data,
//   //         status: error.response?.status
//   //       });
        
//   //       // On error, use localStorage as fallback
//   //       const fallbackStatus = localData.subscription_status || 'inactive';
//   //       console.log('[Subscription Debug] Using fallback status:', fallbackStatus);
//   //       setSubscriptionStatus(fallbackStatus);
//   //     } finally {
//   //       console.log('[Subscription Debug] Setting loading to false');
//   //       setLoading(false);
//   //     }
//   //   };

//   //   verifyBasePlanStatus();
//   // }, [dispatch, hospitalID]);
// useEffect(() => {
//     const verifyBasePlanStatus = async () => {
//       console.log('[Subscription Debug] Starting verification...');
      
//       // 1. LocalStorage se loginData nikalein
//       const localDataString = localStorage.getItem('loginData');
//       let localData = localDataString ? JSON.parse(localDataString) : {};
      
//       try {
//         if (hospitalID) {
//           // 2. Turant UI update (taki user block na ho)
//           if (localData.subscription_status) {
//             setSubscriptionStatus(localData.subscription_status);
//           }

//           // 3. Server se current status mangwayein
//           const response = await dispatch(getAccountStatus(hospitalID));
          
//           const currentStatus = response?.overallStatus || response?.subscription_status || 'inactive';
//           const currentType = response?.currentPlan?.businessType || response?.Subscription_type || null;

//           // 4. Sync Logic: Agar status badla hai toh backend update karein
//           if (localData.subscription_status !== currentStatus || localData.Subscription_type !== currentType) {
            
//             // Local Storage values update karein
//             localData.subscription_status = currentStatus;
//             localData.Subscription_type = currentType;
//             localStorage.setItem('loginData', JSON.stringify(localData));
//             localStorage.setItem('subscriptionStatus', currentStatus);
            
//             setSubscriptionStatus(currentStatus);

//             // 5. FULL PAYLOAD (Jaisa aapne manga hai)
//             // Hum localData se saari fields nikaal kar bhej rahe hain
//             const fullUpdatePayload = {
//               hospitalID: hospitalID,
//               username: localData.username || "",
//               first_name: localData.first_name || "",
//               last_name: localData.last_name || "",
//               email: localData.email || "",
//               mobile: localData.mobile || "",
//               password: localData.password , // 123
//               role: localData.role || "Admin",
//               subscription_status: currentStatus, // New active/inactive status
//               Subscription_type: currentType,     // New subscription type
//               app_status: localData.app_status || "enabled"
//             };

//             console.log('[Subscription Debug] Dispatching updateUser with ALL fields:', fullUpdatePayload);
            
//             // Dispatch update action
//             dispatch(updateUser(fullUpdatePayload));
//           } else {
//             console.log('[Subscription Debug] Everything is in sync.');
//           }

//           // Profile load karein
//           dispatch(getDoctorProfileById(hospitalID));
//         }
//       } catch (error) {
//         console.error("[Subscription Debug] Sync Error:", error);
//         setSubscriptionStatus(localData.subscription_status || 'inactive');
//       } finally {
//         setLoading(false);
//       }
//     };

//     verifyBasePlanStatus();
//   }, [dispatch, hospitalID]);
//   const hasBlogAddon = businessAddons?.some(
//   (addon) => addon.addon_name === "Blog Management" && addon.status?.toLowerCase() === "active"
// );
//   const handleLogout = (e) => {
//     e.preventDefault();
//     dispatch(logout());
//   };

//   const handleRestrictedClick = (e, featureName) => {
//     e.preventDefault();
//     setRestrictedFeature(featureName);
//     setShowSubscriptionModal(true);
//   };

//   const handleUpgradeNow = () => {
//     setShowSubscriptionModal(false);
//     history.push('/doctor/plan-selection');
//     if (onClose) onClose();
//   };

//   const handleCancel = () => {
//     setShowSubscriptionModal(false);
//   };

//   const handleMenuItemClick = () => {
//     if (isMobile && onClose) {
//       onClose();
//     }
//   };

//   useEffect(() => {
//     if (hospitalID) {
//       dispatch(getDoctorProfileById(hospitalID));
//     }
//   }, [dispatch, hospitalID]);

//   const isActive = (path) => currentPath === path;
  
//   // Log current subscription status for debugging
//   console.log('[Subscription Debug] Current subscriptionStatus state:', subscriptionStatus);
//   console.log('[Subscription Debug] isSubscriptionActive check:', String(subscriptionStatus).toLowerCase() === 'active');
  
//   const isSubscriptionActive = String(subscriptionStatus).toLowerCase() === 'active';

//   // Menu configuration
//     const menuItems = [
    
//     { path: '/doctor/dashboard', icon: 'fas fa-columns', label: 'Dashboard', requiresSubscription: true },
//     { path: '/doctor/appointments', icon: 'fas fa-calendar-check', label: 'Appointments', requiresSubscription: true },
//     { path: '/doctor/my-patients', icon: 'fas fa-user-injured', label: 'Patients', requiresSubscription: true },
//     { path: '/doctor/schedule-timings', icon: 'fas fa-hourglass-start', label: 'Schedule Timings', requiresSubscription: true },
//     { path: '/doctor/reminder-tab', icon: 'fa-solid fa-calendar-check', label: 'Reminder', requiresSubscription: true },
//     { path: '/doctor/Exercise-chart', icon: 'fa-solid fa-person-running', label: 'Exercise-chart', requiresSubscription: true },
//     { path: '/doctor/diet-chart', icon: 'fas fa-bowl-rice', label: 'diet-chart', requiresSubscription: true },
//     { path: '/doctor/reviews', icon: 'fas fa-star', label: 'Reviews', requiresSubscription: true },
//     { path: '/doctor/chat', icon: 'fas fa-comments', label: 'Messages', requiresSubscription: true, badge: 23 },
//     { path: '/doctor/profile-settings', icon: 'fas fa-user-cog', label: 'Profile Settings', requiresSubscription: true },
//     { path: '/doctor/my-blogs', icon: 'fas fa-blog', label: 'Blogs', requiresSubscription: true },
//     { path: '/doctor/social-media', icon: 'fas fa-share-alt', label: 'Social Media', requiresSubscription: true },
//     { path: '/doctor/change-password', icon: 'fas fa-lock', label: 'Change Password', requiresSubscription: true },
//     { path: '/doctor/ReportSettingsEditor', icon: 'fas fa-file-alt', label: 'Report Settings', requiresSubscription: true },
//     { path: '/doctor/transaction-list', icon: 'fas fa-exchange-alt', label: 'Transactions', requiresSubscription: true },
//     { path: '/doctor/plan-selection', icon: 'fas fa-cog', label: 'System Setting', requiresSubscription: false },
//     { path: '/doctor/payout-history', icon: 'fas fa-history', label: 'Payout History', requiresSubscription: true },

    
    
//   ];

//   // const renderMenuItem = (item) => {
//   //   const isItemActive = isActive(item.path);
//   //   const canAccess = isSubscriptionActive || !item.requiresSubscription;
    
//   //   console.log(`[Subscription Debug] Menu item "${item.label}" - canAccess: ${canAccess}, isSubscriptionActive: ${isSubscriptionActive}, requiresSubscription: ${item.requiresSubscription}`);

//   //   if (!canAccess) {
//   //     return (
//   //       <li key={item.path} className="locked-item">
//   //         <a
//   //           href="#restricted"
//   //           className="restricted-link"
//   //           onClick={(e) => handleRestrictedClick(e, item.label)}
//   //         >
//   //           <i className={item.icon} />
//   //           <span>{item.label}</span>
//   //           <i className="fas fa-lock lock-icon" />
//   //         </a>
//   //       </li>
//   //     );
//   //   }

//   //   return (
//   //     <li key={item.path} className={isItemActive ? 'active' : ''}>
//   //       <Link to={item.path} onClick={handleMenuItemClick}>
//   //         <i className={item.icon} />
//   //         <span>{item.label}</span>
//   //         {item.badge && <small className="unread-msg">{item.badge}</small>}
//   //       </Link>
//   //     </li>
//   //   );
//   // };
// const renderMenuItem = (item) => {
//   const isItemActive = isActive(item.path);
  
//   // 1. सबसे पहले पहचानें कि क्या यह 'Blogs' वाला menu है?
//   const isBlogItem = item.label === 'Blogs';

//   // 2. Logic: Access कब देना है?
//   let canAccess = false;

//   if (!item.requiresSubscription) {
//     // अगर item को subscription की ज़रुरत ही नहीं है (जैसे System Setting)
//     canAccess = true; 
//   } else if (isSubscriptionActive) {
//     // अगर Base Plan Active है
//     if (isBlogItem) {
//       // अगर 'Blogs' है, तो check करो addon है या नहीं
//       canAccess = hasBlogAddon; 
//     } else {
//       // बाकी सब items के लिए Base Plan Active होना काफी है
//       canAccess = true;
//     }
//   }

//   // 3. अगर access नहीं है, तो Locked UI दिखाओ
//   if (!canAccess) {
//     return (
//       <li key={item.path} className="locked-item">
//         <a
//           href="#restricted"
//           className="restricted-link"
//           onClick={(e) => {
//             // यहाँ click करने पर सही message दिखाएं
//             const message = (isSubscriptionActive && isBlogItem && !hasBlogAddon) 
//               ? "Blog Management Addon" // अगर प्लान है पर एडोन नहीं है
//               : item.label;           // अगर प्लान ही नहीं है
//             handleRestrictedClick(e, message);
//           }}
//         >
//           <i className={item.icon} />
//           <span>{item.label}</span>
//           <i className="fas fa-lock lock-icon" />
//         </a>
//       </li>
//     );
//   }

//   // 4. अगर सब सही है, तो normal Link दिखाओ
//   return (
//     <li key={item.path} className={isItemActive ? 'active' : ''}>
//       <Link to={item.path} onClick={handleMenuItemClick}>
//         <i className={item.icon} />
//         <span>{item.label}</span>
//         {item.badge && <small className="unread-msg">{item.badge}</small>}
//       </Link>
//     </li>
//   );
// };
//   if (loading) {
//     return (
//       <div className="profile-sidebar" style={isMobile ? { height: '100vh', overflowY: 'auto' } : {}}>
//         <div className="loading-section">
//           <div className="spinner-border text-primary" role="status">
//             <span className="sr-only">Loading...</span>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <style>
//         {`
//           .profile-sidebar::-webkit-scrollbar { display: none; }
//           .profile-sidebar { -ms-overflow-style: none; scrollbar-width: none; }
//         `}
//       </style>
      
//       <div className="profile-sidebar" style={isMobile ? { height: '100vh', overflowY: 'auto' } : {}}>
//         {/* Mobile Close Button */}
//         {isMobile && (
//           <div className="mobile-sidebar-header">
//             <button
//               className="btn-danger"
//               onClick={onClose}
//               aria-label="Close sidebar"
//             >×</button>
//           </div>
//         )}

//         {/* Profile Widget */}
//         <div className="widget-profile pro-widget-content">
//           <div className="profile-info-widget">
//             <div className="booking-doc-img">
//               <img
//                 src={
//                   doctorProfile?.uploadPhoto
//                     ? `${imgUrl}${doctorProfile.uploadPhoto}`
//                     : "/assets/img/defaultDoctorProfile.jpg"
//                 }
//                 alt="User"
//                 onError={(e) => {
//                   e.target.src = "/assets/img/defaultDoctorProfile.jpg";
//                 }}
//               />
//             </div>
            
//             <div className="profile-det-info">
//               <h3>
//                 Dr. {doctorProfile?.firstName || 'Loading...'} {doctorProfile?.lastName || ''}
//               </h3>
//               <div className="patient-details">
//                 {doctorProfile?.Educations?.length > 0 ? (
//                   doctorProfile.Educations.map((edu, i) => (
//                     <h5 className="mb-0" key={edu.id || i}>
//                       {edu.Degree}
//                       {i < doctorProfile.Educations.length - 1 ? ', ' : ''}
//                     </h5>
//                   ))
//                 ) : (
//                   <h5>No Education Info</h5>
//                 )}

//                 <div className="mt-2">
//                   {doctorProfile?.Specializations?.length > 0 ? (
//                     doctorProfile.Specializations.map((spec, i) => (
//                       <span
//                         key={spec.id || i}
//                         className="badge badge-info mr-1 mb-1"
//                       >
//                         {spec.Specialization}
//                       </span>
//                     ))
//                   ) : (
//                     <span className="badge badge-secondary">No Specializations</span>
//                   )}
//                 </div>

//                 {/* Subscription Status Badge */}
//                 <div className="mt-2">
//                   <span className={`badge ${isSubscriptionActive ? 'badge-success' : 'badge-warning'}`}>
//                     {isSubscriptionActive ? 'Active Subscription' : 'Subscription Required'}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Navigation Menu */}
//         <div className="dashboard-widget">
//           <nav className="dashboard-menu">
//             <ul>
//               {menuItems.map(renderMenuItem)}

//               {/* Logout Button */}
//               <li>
//                 <a href="#logout" onClick={handleLogout}>
//                   <i className="fas fa-sign-out-alt" />
//                   <span>Logout</span>
//                 </a>
//               </li>
//             </ul>
//           </nav>
//         </div>
//       </div>
//     </>
//   );
// };

// export default DoctorSidebar;



























import React, { useEffect, useState } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getDoctorProfileById } from '../../actions/doctorActions';
import { logout } from 'src/actions/loginAction';
import { imgUrl } from 'src/actions/types';
import './DoctorSidebar.css';
import { getBusinessAddons } from 'src/actions/businessAddonActions';

// ============================================================
// DOCTOR SIDEBAR — SIMPLE VERSION
//
// Image ke flow ke hisaab se:
//   - subscription_status Redux (loginReducer) se aata hai
//   - getAccountStatus API call NAHI hoti yahan
//   - Plan purchase → loginAction.updateSubscriptionStatus → Redux update
//   - Sidebar automatically re-render hoti hai
// ============================================================

const DoctorSidebar = ({ onClose, isMobile }) => {
    const location    = useLocation();
    const history     = useHistory();
    const dispatch    = useDispatch();
    const currentPath = location.pathname;

    // ─── hospitalID localStorage se ──────────────────────────
    const hospitalID = parseInt(localStorage.getItem('hospitalCode'), 10);

    // ─── Redux se data lo ────────────────────────────────────
    const { profileData: doctorProfile } = useSelector(
        (state) => state.doctorProfile
    );

    // ✅ IMAGE KE STEP 7, 8, 9:
    // subscription_status seedha loginReducer se lo
    // getAccountStatus API call ki zarurat nahi
    const subscriptionStatus = useSelector(
        (state) => state.loginReducer.subscriptionStatus
    );

    // Blog addon ke liye businessAddons (optional)
    const { businessAddons } = useSelector(
        (state) => state.businessAddons || { businessAddons: [] }
    );

    // ─── Loading state ────────────────────────────────────────
    const [loading, setLoading]                       = useState(true);
    const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
    const [restrictedFeature, setRestrictedFeature]   = useState('');

    // ─── Page load par doctor profile aur addons fetch karo ──
    // NOTE: subscription ke liye API call NAHI — wo Redux se aa raha hai
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (hospitalID) {
                    await Promise.all([
                        dispatch(getDoctorProfileById(hospitalID)),
                        dispatch(getBusinessAddons({ hospitalID: hospitalID })),
                    ]);
                }
            } catch (error) {
                console.error('[DoctorSidebar] Fetch error:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [dispatch, hospitalID]);

    // ─── Subscription check ───────────────────────────────────
    // Image step 8: subscription_status === 'active' → unlock
    // Image step 9: subscription_status !== 'active' → lock
    const isSubscriptionActive = subscriptionStatus === 'active';

    // Blog addon check
    const hasBlogAddon = businessAddons?.some(
        (addon) =>
            addon.addon_name === 'Blog Management' &&
            addon.status?.toLowerCase() === 'active'
    );

    // ─── Helper functions ─────────────────────────────────────
    const isActive = (path) => currentPath === path;

    const handleLogout = (e) => {
        e.preventDefault();
        dispatch(logout());
    };

    const handleMenuItemClick = () => {
        if (isMobile && onClose) onClose();
    };

    const handleRestrictedClick = (e, featureName) => {
        e.preventDefault();
        setRestrictedFeature(featureName);
        setShowSubscriptionModal(true);
    };

    const handleUpgradeNow = () => {
        setShowSubscriptionModal(false);
        history.push('/doctor/plan-selection');
        if (onClose) onClose();
    };

    // ─── Menu items ───────────────────────────────────────────
    const menuItems = [
        { path: '/doctor/dashboard',           icon: 'fas fa-columns',         label: 'Dashboard',        requiresSubscription: true  },
        { path: '/doctor/appointments',         icon: 'fas fa-calendar-check',  label: 'Appointments',     requiresSubscription: true  },
        { path: '/doctor/my-patients',          icon: 'fas fa-user-injured',    label: 'Patients',         requiresSubscription: true  },
        { path: '/doctor/schedule-timings',     icon: 'fas fa-hourglass-start', label: 'Schedule Timings', requiresSubscription: true  },
        { path: '/doctor/reminder-tab',         icon: 'fas fa-calendar-check',  label: 'Reminder',         requiresSubscription: true  },
        { path: '/doctor/Exercise-chart',       icon: 'fas fa-running',         label: 'Exercise Chart',   requiresSubscription: true  },
        { path: '/doctor/diet-chart',           icon: 'fas fa-utensils',        label: 'Diet Chart',       requiresSubscription: true  },
        { path: '/doctor/reviews',              icon: 'fas fa-star',            label: 'Reviews',          requiresSubscription: true  },
        { path: '/doctor/chat',                 icon: 'fas fa-comments',        label: 'Messages',         requiresSubscription: true, badge: 23 },
        { path: '/doctor/profile-settings',     icon: 'fas fa-user-cog',        label: 'Profile Settings', requiresSubscription: true  },
        { path: '/doctor/my-blogs',             icon: 'fas fa-blog',            label: 'Blogs',            requiresSubscription: true, isBlogItem: true },
        { path: '/doctor/social-media',         icon: 'fas fa-share-alt',       label: 'Social Media',     requiresSubscription: true  },
        { path: '/doctor/change-password',      icon: 'fas fa-lock',            label: 'Change Password',  requiresSubscription: true  },
        { path: '/doctor/ReportSettingsEditor', icon: 'fas fa-file-alt',        label: 'Report Settings',  requiresSubscription: true  },
        { path: '/doctor/transaction-list',     icon: 'fas fa-exchange-alt',    label: 'Transactions',     requiresSubscription: true  },
        // ✅ Image step 9: System Setting hamesha open — plan-selection tak jaana chahiye
        { path: '/doctor/plan-selection',       icon: 'fas fa-cog',             label: 'System Setting',   requiresSubscription: false },
        { path: '/doctor/payout-history',       icon: 'fas fa-history',         label: 'Payout History',   requiresSubscription: true  },
    ];

    // ─── Render each menu item ────────────────────────────────
    const renderMenuItem = (item) => {
        const isItemActive = isActive(item.path);

        // Access logic
        let canAccess = false;

        if (!item.requiresSubscription) {
            canAccess = true; // System Setting hamesha open
        } else if (isSubscriptionActive) {
            if (item.isBlogItem) {
                canAccess = hasBlogAddon; // Blog ke liye addon bhi chahiye
            } else {
                canAccess = true; // Baaki sab ke liye subscription kaafi hai
            }
        }

        // Lock dikhao
        if (!canAccess) {
            const lockMessage =
                isSubscriptionActive && item.isBlogItem && !hasBlogAddon
                    ? 'Blog Management Addon required'
                    : `Subscribe to access ${item.label}`;

            return (
                <li key={item.path} className="locked-item">
                    <a
                        href="#restricted"
                        className="restricted-link"
                        onClick={(e) => handleRestrictedClick(e, lockMessage)}
                    >
                        <i className={item.icon} />
                        <span>{item.label}</span>
                        <i className="fas fa-lock lock-icon" />
                    </a>
                </li>
            );
        }

        // Normal link
        return (
            <li key={item.path} className={isItemActive ? 'active' : ''}>
                <Link to={item.path} onClick={handleMenuItemClick}>
                    <i className={item.icon} />
                    <span>{item.label}</span>
                    {item.badge && <small className="unread-msg">{item.badge}</small>}
                </Link>
            </li>
        );
    };

    // ─── Loading spinner ──────────────────────────────────────
    if (loading) {
        return (
            <div
                className="profile-sidebar"
                style={isMobile ? { height: '100vh', overflowY: 'auto' } : {}}
            >
                <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    <p style={{ marginTop: '12px', color: '#999', fontSize: '14px' }}>
                        Loading...
                    </p>
                </div>
            </div>
        );
    }

    // ─── Main Sidebar UI ──────────────────────────────────────
    return (
        <>
            <style>{`
                .profile-sidebar::-webkit-scrollbar { display: none; }
                .profile-sidebar { -ms-overflow-style: none; scrollbar-width: none; }
                .locked-item .restricted-link { opacity: 0.5; cursor: not-allowed; display: flex; align-items: center; }
                .lock-icon { margin-left: auto; color: #dc3545; font-size: 12px; }
            `}</style>

            <div
                className="profile-sidebar"
                style={isMobile ? { height: '100vh', overflowY: 'auto' } : {}}
            >
                {/* Mobile close button */}
                {isMobile && (
                    <div className="mobile-sidebar-header">
                        <button className="btn-danger" onClick={onClose}>×</button>
                    </div>
                )}

                {/* Doctor Profile */}
                <div className="widget-profile pro-widget-content">
                    <div className="profile-info-widget">
                        <div className="booking-doc-img">
                            <img
                                src={
                                    doctorProfile?.uploadPhoto
                                        ? `${imgUrl}${doctorProfile.uploadPhoto}`
                                        : '/assets/img/defaultDoctorProfile.jpg'
                                }
                                alt="Doctor"
                                onError={(e) => { e.target.src = '/assets/img/defaultDoctorProfile.jpg'; }}
                            />
                        </div>

                        <div className="profile-det-info">
                            <h3>Dr. {doctorProfile?.firstName || 'Doctor'} {doctorProfile?.lastName || ''}</h3>

                            <div className="patient-details">
                                {doctorProfile?.Educations?.length > 0 ? (
                                    doctorProfile.Educations.map((edu, i) => (
                                        <h5 className="mb-0" key={edu.id || i}>
                                            {edu.Degree}{i < doctorProfile.Educations.length - 1 ? ', ' : ''}
                                        </h5>
                                    ))
                                ) : <h5>No Education Info</h5>}

                                <div className="mt-2">
                                    {doctorProfile?.Specializations?.length > 0 ? (
                                        doctorProfile.Specializations.map((spec, i) => (
                                            <span key={spec.id || i} className="badge badge-info mr-1 mb-1">
                                                {spec.Specialization}
                                            </span>
                                        ))
                                    ) : <span className="badge badge-secondary">No Specializations</span>}
                                </div>

                                {/* Subscription status badge */}
                                <div className="mt-2">
                                    <span className={`badge ${isSubscriptionActive ? 'badge-success' : 'badge-warning'}`}>
                                        {isSubscriptionActive ? '✓ Active Plan' : 'No Active Plan'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Navigation Menu */}
                <div className="dashboard-widget">
                    <nav className="dashboard-menu">
                        <ul>
                            {menuItems.map(renderMenuItem)}
                            <li>
                                <a href="#logout" onClick={handleLogout}>
                                    <i className="fas fa-sign-out-alt" />
                                    <span>Logout</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

            {/* Subscription Modal */}
            {showSubscriptionModal && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    <div style={{
                        backgroundColor: '#fff', borderRadius: '12px', padding: '30px',
                        maxWidth: '400px', width: '90%', textAlign: 'center',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                    }}>
                        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔒</div>
                        <h4 style={{ color: '#333', marginBottom: '10px' }}>Access Restricted</h4>
                        <p style={{ color: '#666', marginBottom: '24px' }}>
                            <strong>{restrictedFeature}</strong>
                        </p>
                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                            <button
                                onClick={() => setShowSubscriptionModal(false)}
                                style={{ padding: '10px 20px', border: '1px solid #ddd', borderRadius: '8px', cursor: 'pointer', backgroundColor: '#f8f9fa' }}
                            >Cancel</button>
                            <button
                                onClick={handleUpgradeNow}
                                style={{ padding: '10px 20px', backgroundColor: '#0084d9', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }}
                            >View Plans</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default DoctorSidebar;